import { hydrateRoot } from 'react-dom/client';
import { type FC } from 'react';
import serverVars from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { useLazyLoadQuery, RelayEnvironmentProvider } from 'react-relay';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { trackPageview } from 'dibs-tracking';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import popularSearchesSitemapRootQuery from '../queries/popularSearchesSitemapRootQuery';
import { PopularSearchesSitemapLayout } from '../popularSearchesSitemap/components/PopularSearchesSitemapLayout';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';

import { type popularSearchesSitemapRootQuery as popularSearchesSitemapRootQueryType } from '../queries/__generated__/popularSearchesSitemapRootQuery.graphql';

const relayVariables = serverVars.get('relayVariables');
const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

const ComponentWrapper: FC = () => {
    const data = useLazyLoadQuery<popularSearchesSitemapRootQueryType>(
        popularSearchesSitemapRootQuery,
        relayVariables,
        {
            fetchPolicy: 'store-only',
        }
    );
    return <PopularSearchesSitemapLayout relayVariables={relayVariables} viewer={data.viewer} />;
};

initializeDBL().then(() => {
    hydrateRoot(
        document.getElementById('js-root') as HTMLElement,
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <ErrorBoundary fallback={({ error }) => <Error500Layout error={error} />}>
                <RelayEnvironmentProvider environment={environment}>
                    <ComponentWrapper />
                </RelayEnvironmentProvider>
            </ErrorBoundary>
        </IntlProvider>
    );
    trackPageview({
        additional: {
            pageType: 'Results',
            pageSubType: 'Popular Searches',
        },
    });
});
